import actions from "./actions";

const initState = {
  organizations: [],
  cities: [],
  organizationRestaurants: [],
  reloadOrganizations: false,
  fbdbversions: [],
  menuConfiguration: null,
  loadingOrganization: true,
  allOrganizationsByUrl: [],
};

export default function reducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_ORGANIZATIONS_REQUEST:
      return {
        ...state,
        loadingOrganization: true,
      };
    case actions.GET_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.organizations,
        loadingOrganization: false,
      };

    case actions.ADD_ORGANIZATION_SUCCESS:
      return {
        ...state,
        reloadOrganizations: !state.reloadOrganizations,
      };

    case actions.UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        reloadOrganizations: !state.reloadOrganizations,
      };

    case actions.DELETE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        reloadOrganizations: !state.reloadOrganizations,
      };

    case actions.GET_ORGANIZATION_RESTAURANTS_SUCCESS:
      return {
        ...state,
        organizationRestaurants: action.organizationRestaurants,
      };

    case actions.GET_CITIES_SUCCESS:
      return {
        ...state,
        cities: action.cities,
      };

    case actions.GET_FIREBIRD_DATABASE_VERSIONS_SUCCESS:
      return {
        ...state,
        fbdbversions: action.fbdbversions,
      };

    case actions.GET_FIREBIRD_DATABASE_VERSIONS_CLOSE_MODAL:
      return {
        ...state,
        fbdbversions: [],
      };

    case actions.GET_FIREBIRD_DATABASE_VERSIONS_BY_USER_SUCCESS:
      return {
        ...state,
        fbdbversions: action.fbdbversions,
      };

    case actions.GET_MENU_CONFIGURATION_SUCCESS:
      return {
        ...state,
        menuConfiguration: action.menuConfiguration,
      };

    case actions.GET_ALL_ORGANIZATIONS_BY_URL_REQUEST:
      return {
        ...state,
        loadingOrganization: true,
      };
    case actions.GET_ALL_ORGANIZATIONS_BY_URL_SUCCESS:
      return {
        ...state,
        allOrganizationsByUrl: action.organizations,
        loadingOrganization: false,
      };
    default:
      return state;
  }
}
